module.exports = __webpack_public_path__ + "static/img/Maskbook_F2A4762.0a310d4.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/outreach/Maskbook_F2A4762.jpg
// module id = cf09
// module chunks = 0